import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './jsx/pages/Home';
import PricingPage from './jsx/pages/PricingPage';
import Login from './jsx/pages/Login';
import WebPage_Login from './jsx/pages/webPage_Login';
import Dashboard from './jsx/pages/Dashboard';
import ToastDemo from './jsx/components/ToastDemo';
import PrivacyPolicy from './jsx/pages/PrivacyPolicy';
import TermsAndConditions from './jsx/pages/TermsAndConditions';

const AppRouter = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/extension_login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/toast-demo" element={<ToastDemo />} />
      <Route path="/privacy_policy" element={<PrivacyPolicy />} />
      <Route path="/terms_and_conditions" element={<TermsAndConditions />} />
      <Route path="/webpagelogin" element={<WebPage_Login />} />
    </Routes>
  </Router>
);

export default AppRouter;